import { Component, Input, OnInit } from '@angular/core';
import { OkechargeChargepoint } from '../../../../api/chargepoints-api.service';
import { CopiableInfoComponent } from '../../../../elements/copiable-info/copiable-info.component';

@Component({
  selector: 'app-okecharge-vendor-info',
  templateUrl: './okecharge-vendor-info.component.html',
  styleUrls: ['./okecharge-vendor-info.component.scss'],
  imports: [CopiableInfoComponent]
})
export class OkechargeVendorInfoComponent implements OnInit {

  @Input() chargepoint?: OkechargeChargepoint;

  constructor() { }

  ngOnInit() {
  }

}
